// extracted by mini-css-extract-plugin
export default {"tableWrapper":"styles_tableWrapper__Q+EHj","pointer":"styles_pointer__jJ4v3","disabled":"styles_disabled__oLciT"};